import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'bytesFormatter'})
export class BytesFormatterPipe implements PipeTransform {

    private labels = ['Кб', 'Мб', 'Гб'];

    transform(bytes: number): string {
        let size: number = bytes;
        let sizeLabel = '';

        this.labels.some((label, index) => {
            size = +(+size / 1024).toFixed(2);
            /**
             * Размеры в Кб округляем, чтобы не было дробной части
             */
            if (index === 0) {
                size = Math.round(size);
            }
            sizeLabel = size + ' ' + label;
            return size < 500;
        });
        return sizeLabel;
    }
}

